import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dashboard_card_icon_menu_left",
  "use": "dashboard_card_icon_menu_left-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"dashboard_card_icon_menu_left\"><g opacity=\".2\" stroke=\"#2D2C34\" stroke-width=\"2\" stroke-linecap=\"round\"><path d=\"M10.226 3.642 5.959 7.908M5.959 7.908l4.267 4.267\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol